import styles from "./Icons.module.css";

export const PlusIcon = () => (
  <div className={styles.iconCircle}>
    <span className={styles.plusIcon}></span>
  </div>
);

export const MinusIcon = () => (
  <div className={styles.iconCircle}>
    <span className={styles.minusIcon}></span>
  </div>
);

export const NotRecommendIcon = () => (
  <span className={styles.notRecommendIcon}></span>
);

export const RecommendIcon = () => (
  <span className={styles.recommendIcon}></span>
);
